module.exports = __webpack_public_path__ + "static/img/2.927aa39.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/board/components/DownloadData/images/2.png
// module id = sSEp
// module chunks = 1